import { AutocompleteInput, ReferenceInput, useEditController, useGetList } from "react-admin";
import { useController } from 'react-hook-form';


export const FaqCategoriesAutoComplete = (props: any) => {
    const { field } = useController({ name: props.source });
    const { data, isLoading } = useGetList(
        "faq-categories",
        {
            pagination: { page: 1, perPage: 50 },
            sort: { field: "created_at", order: "DESC" },
            filter: { deleted: false },
        },
        {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        }
    );

    return (
        <AutocompleteInput
            {...props}
            source="categoryId"
            label="Category"
            choices={data || []}
            optionText="name"
            optionValue="id"
            loading={isLoading}
        />
    );
};
